<template>
  <div v-if="visible" :class="rootClass">
    <slot />
  </div>
</template>

<script>
import {inject, unref} from 'vue';

export default {
  name: 'HitTab',
  components: {},
  props: {
    id: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      required: false,
      default: null,
    },
    iconColor: {
      type: String,
      required: false,
      default: null,
    },
    tabClass: {
      type: String,
      required: false,
      default: '',
    },
    titleClass: {
      type: String,
      required: false,
      default: '',
    },
    pulse: {
      type: Boolean,
      required: false,
      default: false,
    },
    visible: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  setup() {
    const hitTabsFillHeight = inject('hitTabsFillHeight', false);
    return {hitTabsFillHeight};
  },
  computed: {
    rootClass() {
      return unref(this.hitTabsFillHeight)
        ? 'h-full min-h-0 flex flex-col'
        : undefined;
    },
  },
  methods: {
    onTabClick($event) {
      this.$emit('click', this.title);
      $event.stopImmediatePropagation();
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss"></style>
